var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPorteriaWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Porteria_White",
    "data-name": "Porteria White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.313,
    height: 240.313,
    viewBox: "0 0 240.313 240.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbfaf1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M218.482,349.324a5.752,5.752,0,1,0,4.063-1.684A5.752,5.752,0,0,0,218.482,349.324Z",
    transform: "translate(-113.552 -182.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M443.239,393.55a5.758,5.758,0,1,0,4.062,1.69A5.758,5.758,0,0,0,443.239,393.55Z",
    transform: "translate(-233.972 -206.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M235.618,124.852H214.951V85.475a23.551,23.551,0,0,0-18.374-22.863l-15.342-3.364a24.565,24.565,0,0,0,8.613-18.682V24.622a24.622,24.622,0,1,0-49.245,0V40.57a24.561,24.561,0,0,0,8.6,18.669L133.859,62.6A23.551,23.551,0,0,0,115.47,85.465v20.609H90.117a4.7,4.7,0,0,0-4.7,4.7v14.082H52.571V111.707H72.277a4.7,4.7,0,0,0,4.7-4.691V56.325a4.7,4.7,0,0,0-4.7-4.7H4.7a4.691,4.691,0,0,0-4.7,4.7v50.692a4.691,4.691,0,0,0,4.7,4.691H24.4v13.145H4.7A4.691,4.691,0,0,0,0,129.543v22.532a4.691,4.691,0,0,0,4.7,4.691H20.667v78.852a4.691,4.691,0,0,0,4.676,4.7H214.97a4.691,4.691,0,0,0,4.691-4.7v-23a4.7,4.7,0,0,0-9.387,0v18.307H30.039V176.472H90.117a4.7,4.7,0,1,0,0-9.387H30.039V156.766H210.274v18.307a4.7,4.7,0,0,0,9.387,0V156.766h15.957a4.691,4.691,0,0,0,4.7-4.691V129.543a4.691,4.691,0,0,0-4.7-4.691ZM149.979,37.244h6.46a43.175,43.175,0,0,0,24.031-7.209V40.57a15.236,15.236,0,1,1-30.472,0Zm15.236,27.948a24.637,24.637,0,0,0,4.282-.38l-4.326,9.776-4.35-9.8A24.686,24.686,0,0,0,165.215,65.192Zm0-55.806A15.26,15.26,0,0,1,179.37,19a33.855,33.855,0,0,1-22.931,8.877h-6.46V24.622A15.255,15.255,0,0,1,165.215,9.387ZM124.843,85.465a14.1,14.1,0,0,1,11.011-13.693l16.2-3.552,8.81,19.835a4.7,4.7,0,0,0,8.579,0l8.81-19.84,16.3,3.566a14.092,14.092,0,0,1,11.021,13.693v39.378H154.891V110.77a4.7,4.7,0,0,0-4.7-4.7H124.852Zm-30.039,30h50.7v9.391H94.813ZM9.387,61.04h58.2v41.305H52.494a14.082,14.082,0,0,0-28.016,0H9.387Zm24.406,42.776a4.7,4.7,0,1,1,9.387,0V124.9H33.793Zm197.134,43.612H9.387V134.239h221.54Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorteriaWhite);
export default __webpack_public_path__ + "static/media/Porteria White.2253929ee81870d5cc765c5ca3a931de.svg";
export { ForwardRef as ReactComponent };